import React, { useState, useEffect, useContext, useRef } from "react";
import { Layout, theme, Button, notification, Space, Badge } from "antd";
import { Avatar } from "antd";
import { FormOutlined, LogoutOutlined, UserOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "antd";
import * as actionTypes from "../../redux/Auth/AuthTypes";
import { SocketContext } from "../../context/socketContext";
import { getTickets } from "../../redux/Tickets/TicketsActions";
import { getProfile } from "../../redux/Profile/ProfileActions";
import { playNotificationSound, visitorSounds } from "../../helpers/sounds";
import { useNavigate, useLocation } from "react-router-dom";
import { GetOverAllUsers } from "../../redux/Users/UsersActions";
import Clock from "../clock";
import { persistor } from "../../redux/store";
import { getOmni } from "../../redux/OmniChannels/OmniChannelsActions";
import * as newActionTypes from "../../redux/Tickets/TicketsTypes";
import { normalizeVisitorUniqueId, visitorsUniqueKeyEqual } from "../../helpers/visitorId";
import { getStoredAuthToken, handleForceLogout } from "../../helpers/forceLogout";
import HeaderNotification from "../headernotification/HeaderNotification";


const Headers = ({ collapsed = false, setCollapsed = () => {}, isMobile = false }) => {
  const userData = useSelector((state) => state.Auth.userData);
  const usertoken = useSelector((state) => state.Auth.token);
  const { omniData } = useSelector((state) => state.OmniChannelsReducer);
  const ticketsData = useSelector((state) => state.TicketsReducer.data);
  const [IsActive, setIsActive] = useState("22");
  const { Socket, VisitorData, setVisitorData, SelectedVisitorData, setSelectedVisitorData, connected } = useContext(SocketContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [recivedTrasferdata, setrecivedTrasferdata] = useState([]);
  const [tempTicket, settempTicket] = useState([]);
  const userSoundsRef = useRef(userData?.sounds);

  useEffect(() => {
    userSoundsRef.current = userData?.sounds;
  }, [userData?.sounds]);

  const pageTitles = {
    "/": "Home",
    "/brands": "Brands",
    "/users": "Users",
    "/analytics": "Analytics",
    "/visitors": "Visitors",
    "/monitor": "Monitor",
    "/agents": "Agents",
    "/shortcuts": "Shortcuts",
    "/shortcuts/addshortcut": "Add Shortcut",
    "/banned": "Banned",
    "/personal": "Personal",
    "/account": "Account",
    "/triggers": "Triggers",
    "/triggers/addtriggers": "Add Trigger",
    "/departments": "Departments",
    "/offlineStatus": "Offline Status",
    "/offlineStatus/status": "Add Status",
    "/tickets": "Tickets",
    "/create-ticket": "Create Ticket",
    "/history": "History",
    "/feedback": "FeedBack",
    "/agent-roles": "Agent Roles",
    "/email-settings": "Email Settings",
    "/email": "Email",
    "/omnichannels": "Omni Channels",
  };

  const getPageTitle = (pathname) => {
    if (pageTitles[pathname]) return pageTitles[pathname];
    if (pathname.startsWith("/triggers/edit/")) return "Edit Trigger";
    if (pathname.startsWith("/brands/")) return "Brand Widget Settings";
    return "Home";
  };

  useEffect(() => {
    let data = {
      companyId: userData?.companyId,
      id: userData?._id
    }
    dispatch(GetOverAllUsers(data, usertoken));
  }, []);

  useEffect(() => {
    if (ticketsData?.length > 0) {
      settempTicket(ticketsData);
    }
  }, [ticketsData])

  const transferNotiKey = (invite) => {
    const uid = normalizeVisitorUniqueId(invite?.visitorData?.unique_id);
    return uid ? `chat-transfer-${uid}` : "chat-transfer";
  };

  const notificationmsg = (i) => {
    const btn = (x) => (
      <Space>
        <Button onClick={() => onRejct(x)}>
          Reject
        </Button>
        <Button type="primary" onClick={() => onAccept(x)}>
          Confirm
        </Button>
      </Space>
    );
    const visitorName = String(i?.visitorData?.name || "").trim();
    const visitorId = normalizeVisitorUniqueId(i?.visitorData?.unique_id);
    const visitorLabel = visitorName || (visitorId ? `#${visitorId}` : "Unknown visitor");
    const des = (payload) => (
      <>
        <p>You have received a chat from  <span style={{ fontWeight: "bold" }}>{payload?.senderData?.name || "an agent"}</span></p>
        <p>Visitor : <span style={{ fontWeight: "bold" }}>{visitorLabel}</span></p>
      </>
    );
    notification.info({
      key: transferNotiKey(i),
      message: <p style={{ fontWeight: "bold" }}>Chat Request</p>,
      description: des(i),
      btn: btn(i),
      closeIcon: false,
      duration: null,
    });
  }

  useEffect(() => {
    let data = {
      Id: userData?._id,
      companyId: userData?.companyId
    }
    dispatch(getTickets(data));
    dispatch(getProfile(data, usertoken || getStoredAuthToken()));
    dispatch(getOmni({ companyId: userData?.companyId }));
  }, []);


  useEffect(() => {
    if (!Socket || !userData?._id) return;
    const token = usertoken || getStoredAuthToken();
    if (!token) return;

    const agentConnectPayload = {
      agentBrands: userData?.assignBrands,
      agentID: userData?._id,
      token,
      sessionClient: "web",
      role: userData?.role,
      displayName: userData?.sudoName,
      name: userData?.name,
      status: IsActive,
    };

    const emitAgentConnect = () => {
      Socket.emit("agentConnect", agentConnectPayload, (response) => {
        if (!response?.success && response?.error === "session_invalid") {
          handleForceLogout(response?.message, { socket: Socket, dispatch });
        }
      });
    };

    emitAgentConnect();

    const handleConnect = () => {
      emitAgentConnect();
    };
    Socket.on("connect", handleConnect);

    return () => {
      Socket.off("connect", handleConnect);
    };
  }, [Socket, userData, usertoken, IsActive, dispatch]);

  // Visitor / transfer socket listeners (separate from agentConnect lifecycle)
  useEffect(() => {
    if (!Socket) return;

    Socket?.on("VisitorArrive", (data) => {
      setVisitorData(prev => {
        // Socket payloads can format the same visitor id differently (e.g. "[123]" vs "123").
        // Normalize before keying to avoid duplicate rows in the visitors dashboard.
        const visitorMap = new Map(prev.map(v => [normalizeVisitorUniqueId(v?.unique_id), v]));
        visitorMap.set(normalizeVisitorUniqueId(data?.unique_id), data);
        return Array.from(visitorMap.values());
      });
      setSelectedVisitorData(prev =>
        normalizeVisitorUniqueId(prev?.unique_id) === normalizeVisitorUniqueId(data?.unique_id) ? data : prev
      );
    });

    Socket?.on("AllVisitorArrive", (data) => {
      // Same normalization rule as VisitorArrive. Prefer last-seen entry.
      const list = Array.isArray(data) ? data : [];
      const visitorMap = new Map(list.map(v => [normalizeVisitorUniqueId(v?.unique_id), v]));
      setVisitorData(Array.from(visitorMap.values()));
    });

    Socket?.on("VisitorBlocked", (data) => {
      let FindVisitor = VisitorData?.filter((i) => i?.unique_id !== data?.unique_id);
      setVisitorData(FindVisitor);
    });

    Socket?.on("chat_Invite", (data) => {
      let shouldNotify = false;
      setrecivedTrasferdata((prev) => {
        const list = Array.isArray(prev) ? prev : [];
        const already = list.some((i) =>
          visitorsUniqueKeyEqual(i?.visitorData?.unique_id, data?.visitorData?.unique_id)
        );
        if (already) return list;
        shouldNotify = true;
        return [data, ...list];
      });
      if (shouldNotify) {
        notificationmsg(data);
      }
    });

    // After refresh / reconnect: restore pending invites from Redis and re-show them.
    Socket?.on("pendingChatInvites", (list) => {
      const invites = Array.isArray(list) ? list : [];
      if (!invites.length) return;
      setrecivedTrasferdata((prev) => {
        const existing = Array.isArray(prev) ? prev : [];
        const merged = [...existing];
        for (const invite of invites) {
          const already = merged.some((i) =>
            visitorsUniqueKeyEqual(i?.visitorData?.unique_id, invite?.visitorData?.unique_id)
          );
          if (!already) merged.push(invite);
        }
        return merged;
      });
      invites.forEach((invite) => notificationmsg(invite));
    });


    return () => {
      Socket.off("chat_Invite");
      Socket.off("pendingChatInvites");
      Socket.off("VisitorBlocked");
      Socket.off("AllVisitorArrive");
      Socket.off("VisitorArrive");
    };
  }, [Socket]);

  useEffect(() => {
    if (!Socket) return;
    Socket?.on("ticketInbound", async (data) => {
      const index = tempTicket?.findIndex(ticket => ticket._id === data._id);
      if (index !== -1) {
        const updated = [...tempTicket];
        updated[index] = data;
        dispatch({
          type: newActionTypes.GET_TICKETS_SUCCESS,
          payload: updated
        });
      } else {
        let chnagedArrr = [data, ...tempTicket];
        dispatch({
          type: newActionTypes.GET_TICKETS_SUCCESS,
          payload: chnagedArrr
        });
      }
    });
    return () => { }
  }, [tempTicket, Socket])



  const onRejct = (x) => {
    setrecivedTrasferdata((prev) =>
      (prev || []).filter(
        (i) =>
          !visitorsUniqueKeyEqual(
            i?.visitorData?.unique_id,
            x?.visitorData?.unique_id
          )
      )
    );
    Socket.emit("transferRejected", x);
    notification.destroy(transferNotiKey(x));
  };

  const onAccept = (x) => {
    let alldata = {
      ...x,
      agentData: {
        id: userData?._id,
        name: userData?.sudoName
      },
    }
    setrecivedTrasferdata((prev) =>
      (prev || []).filter(
        (i) =>
          !visitorsUniqueKeyEqual(
            i?.visitorData?.unique_id,
            x?.visitorData?.unique_id
          )
      )
    );
    Socket.emit("transferAccepted", alldata);
    notification.destroy(transferNotiKey(x));
  };

  /// Sound when visitorArrives
  useEffect(() => {
    if (!Socket) return;
    const onAlert = () => {
      playNotificationSound(visitorSounds, userSoundsRef.current?.incomingVisitor);
    };
    Socket.on("alert", onAlert);
    return () => {
      Socket.off("alert", onAlert);
    };
  }, [Socket]);

  useEffect(() => {
    let context = new AudioContext();
    context.resume().then((i) => {
    }).catch((e) => { })
  },);
  //// end

  const LogoutUser = () => {
    Socket?.disconnect();
    dispatch({ type: actionTypes.USER_LOGOUT });
    localStorage.removeItem("reduxPersist:root");
    sessionStorage.removeItem("reduxPersist:root");
    persistor.purge();
    navigate("/login");
  };


  const onChnageStatus = (id) => {
    setIsActive(id);
    Socket.emit("changeStatus", {
      agentBrands: userData?.assignBrands,
      agentID: userData?._id,
      displayName: userData?.sudoName,
      name: userData?.name,
      status: id
    });
  };

  const { Header } = Layout;

  const items = [
    {
      label: <h6 className="infoTag">Personal Info</h6>,
      key: "heading",
    },
    {
      label: <div className="infos">{userData?.sudoName}<FormOutlined /></div>,
      key: "1",
      onClick: () => {
        navigate("/personal");
      },
    },
    {
      label: <div className="status online">Online</div>,
      key: "22",
      onClick: () => onChnageStatus("22"),
    },
    {
      label: <div className="status away">Away</div>,
      key: "23",
      onClick: () => onChnageStatus("23"),
    },
    {
      label: <div className="status invi">Invisible</div>,
      key: "24",
      onClick: () => onChnageStatus("24"),
    },
    {
      label: <div style={{ textAlign: 'left' }}>Logout</div>,
      key: "5",
      onClick: () => {
        LogoutUser();
      },
      icon: <LogoutOutlined />,
      className: 'logoutBtn'

    }
  ];

  const {
    token: { colorBgContainer }
  } = theme.useToken();

  return (
    <>
      <div style={{ position: 'relative' }}>
        <Header
          className="header"
          style={{
            background: colorBgContainer,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid',
            borderBottomColor: '#F2F2F2',
          }}
        >
          <div
            className="header-left"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              minWidth: 0,
            }}
          >
            {/* {isMobile && (
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                aria-label={collapsed ? "Open navigation menu" : "Close navigation menu"}
                style={{ flexShrink: 0 }}
              />
            )} */}
            {!isMobile && (
              <h2 style={{ margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {getPageTitle(location.pathname)}
              </h2>
            )}
          </div>
          <div className="topHeader">
            <Clock />
            <div style={{ marginLeft: 10 }}></div>
            <HeaderNotification
              pendingTransfers={recivedTrasferdata}
              onAccept={onAccept}
              onReject={onRejct}
            />
            <Dropdown
              menu={{
                items,
              }}
              trigger={["click"]}
              className="Drops"
              overlayClassName="user-dropdown"
            >
              {/* IsActive */}
              <a onClick={(e) => e.preventDefault()}>
                <Space size={24}>
                  <Badge dot className={IsActive === "22" ? "badgeDotGreen" : IsActive === "23" ? "badgeDotYellow" : "badgeDotgray"}>
                    <Avatar icon={<UserOutlined />} />
                  </Badge>
                </Space>
              </a>

            </Dropdown>

          </div>
        </Header>
      </div>
    </>

  );
};

export default Headers;
